import { motion } from 'framer-motion';
import { User, Users, Building2, Sparkles } from 'lucide-react';

const segments = [
  { icon: User, title: 'Abogado independiente', benefits: ['Ordená causas y clientes en un solo lugar.', 'Gestioná agenda, documentos y tareas.', 'Reducí dependencia de planillas, carpetas y mensajes dispersos.'] },
  { icon: Users, title: 'Estudios pequeños', benefits: ['Coordiná el trabajo entre abogados.', 'Asigná tareas y centralizá documentación.', 'Mejorá el seguimiento de clientes y causas.'] },
  { icon: Building2, title: 'Estudios grandes', benefits: ['Controlá equipos y áreas de trabajo.', 'Organizá mayor volumen de información.', 'Escalá la operación con más usuarios.'] },
  { icon: Sparkles, title: 'Plan a medida', benefits: ['Plataforma adaptada a la marca del estudio.', 'Landing pública y portal cliente propios.', 'Implementación profesional y diferenciada.'] },
];

export default function BenefitsSection() {
  return (
    <section className="relative py-20 lg:py-28 bg-[#050505]" data-testid="benefits-section">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="text-center mb-14">
          <span className="text-[#C9A44C] text-[11px] uppercase tracking-[0.2em] block mb-3">Beneficios</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-medium text-[#F8F6F0] tracking-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            LexOrbit se adapta a la forma de trabajar de <span className="text-[#C9A44C] italic">cada estudio</span>
          </h2>
        </motion.div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {segments.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className="bg-[#141414] border border-[rgba(201,164,76,0.12)] rounded-xl p-5 hover:border-[rgba(201,164,76,0.3)] transition-all duration-400"
                data-testid={`benefit-card-${i}`}>
                <Icon className="w-5 h-5 text-[#C9A44C] mb-3" strokeWidth={1.5} />
                <h3 className="text-[#F8F6F0] text-sm font-semibold mb-3">{s.title}</h3>
                <ul className="space-y-2">
                  {s.benefits.map((b, j) => (
                    <li key={j} className="text-[#B8B8B8] text-[11px] leading-relaxed flex items-start gap-2">
                      <span className="w-1 h-1 rounded-full bg-[#C9A44C] mt-1.5 flex-shrink-0" />{b}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
